import _ from 'lodash';
import { SET_SIDEBAR_CONTENT, SET_SIDEBAR_IS_LOADING } from './sidebarActionCreator';
import { TAction } from '../../actions/types/action';

export default function sidebarContent(state: Partial<any> = {}, action: TAction<any>): Partial<any> {
  switch (action.type) {
    case SET_SIDEBAR_CONTENT: {
      return {
        ...state,
        [action.payload.slug]: {
          ...state[action.payload.slug],
          ...action.payload.params
        }
      };
    }
    case SET_SIDEBAR_IS_LOADING: {
      return {
        ...state,
        [action.payload.slug]: {
          ...state[action.payload.slug],
          isLoading: action.payload.isLoading
        }
      };
    }
    default: {
      return state;
    }
  }
}
